import { ReactNode, useMemo, useState } from 'react'
import FormStepContext from './formStepContext'

const FormStepProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [currentStep, setCurrentStep] = useState<string | undefined>(undefined)
  const value = useMemo(() => ({ currentStep, setCurrentStep }), [currentStep])

  return <FormStepContext.Provider value={value}>{children}</FormStepContext.Provider>
}

export default FormStepProvider
